<template>
  <section>
    <div style="display: flex; flex-direction: column; background: #f8f9fc;">
      <div
        style="display: flex; margin: 0 16px; background"
        :style="{ justifyContent: isMobile ? 'left' : 'center' }"
      >
        <img src="@/assets/icons/ic-system-viabus.svg" style="margin-top: 20px;" />
      </div>
      <div
        style="position: absolute; display: flex; justify-content: center; align-items: center; width: 100%; height: 100%;"
      >
        <div
          style="display: flex; flex-direction: column; align-items: center; margin-bottom: 12vh;"
        >
          <img src="@/assets/icons/icon-32-ic-hourglass.svg" />
          <div class="title">{{ getI18nMessage('expired') }}</div>
          <div class="new-link-hint">{{ getI18nMessage('newLinkHint') }}</div>
        </div>
      </div>
      <Footer :longContactUs="true" :language="language"> </Footer>
    </div>
  </section>
</template>

<script>
import { get } from 'lodash';
import { isMobile } from '@/utils/useragent';

import Footer from '@/components/footer';

const i18n = {
  mobile: {
    expired: {
      th: 'ลิงก์หมดอายุ\nกรุณาใช้ลิงก์ใหม่',
      en: 'Link Expired.\nPlease use a new link.',
    },
    newLinkHint: {
      th: 'คุณสามารถกดขอลิงก์ใหม่\nได้บนแอป ViaBus',
      en: 'You can get a new link by resending\nthe email from the ViaBus app. ',
    },
  },
  desktop: {
    expired: {
      th: 'ลิงก์หมดอายุ\nกรุณาใช้ลิงก์ใหม่',
      en: 'Link Expired.\nPlease use a new link.',
    },
    newLinkHint: {
      th: 'คุณสามารถกดขอลิงก์ใหม่ได้บนแอป ViaBus',
      en: 'You can get a new link by resending the email from the ViaBus app. ',
    },
  },
};

export default {
  components: { Footer },
  computed: {
    isMobile,
  },
  data() {
    return {
      language: 'en',
    };
  },
  watch: {},
  methods: {
    getI18nMessage(key) {
      return get(i18n, `${this.isMobile ? 'mobile' : 'desktop'}.${key}.${this.language}`, '');
    },
  },
  mounted() {
    let lang = get(this.$route.query, 'lang', 'th').trim();
    if (lang === 'en' || lang === 'th') {
      this.language = lang;
    }
  },
};
</script>

<style scoped>
.title {
  font-size: 24px;
  font-weight: bold;
  color: #263373;
  text-align: center;
  margin-top: 24px;
  white-space: pre;
}

.new-link-hint {
  margin-top: 5vh;
  white-space: pre;
  text-align: center;
  font-size: 17px;
  font-weight: 500;
  color: #263373;
}
</style>
